import { IGatsbySvg } from "@bond-london/gatsby-transformer-extracted-svg";
import { IRichTextInformation } from "@bond-london/graphcms-rich-text";
import React from "react";
import { RTF } from "../elements/RTF";

// eslint-disable-next-line import/no-unused-modules
export const TextIntro: React.FC<{
  title?: string | null;
  message?: IRichTextInformation | null;
  shape?: IGatsbySvg;
}> = ({ title, message, shape }) => {
  return (
    <section
      data-component="Text Intro"
      className="page-grid max-width relative gap-y-10 py-60px lg:py-24"
    >
      {shape && (
        <img
          className="col-span-1 col-start-2 row-start-1 w-full lg:row-span-2"
          src={shape.encoded ?? shape.encodedUrl}
          width="72px"
          height="72px"
          alt=""
        />
      )}
      {title && (
        <h1 className="h1-sans-bold col-span-4 col-start-2 row-start-2 md:col-span-6 md:row-start-1 lg:col-span-8 lg:col-start-4">
          {title}
        </h1>
      )}
      {message && (
        <RTF
          className="p6 col-span-4 col-start-2 animate-enter-from-right text-coal md:col-span-6 md:col-start-3 lg:col-span-9 lg:col-start-5"
          fixedParagraphClassName={"p6"}
          content={message}
        />
      )}
    </section>
  );
};
